import script from "./InvertedButton.vue?vue&type=script&setup=true&lang=js"
export * from "./InvertedButton.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/mior/Projects/laravel/nova/silver-surfer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"InvertedButton.vue"]])

export default __exports__